import {
    loginEN
} from "./element/login";
import {
    notfoundEN
} from "./element/notFound";
import {
    footerEN
} from "./element/login";
import {
    formEN,
    stepperBarEN
} from "./element/step";
import {
    step2EN
} from "./element/step";
import {
    step3EN
} from "./element/step";
import {
    step4EN
} from "./element/step";
import {
    step5EN
} from "./element/step";
import {
    formSummitEN
} from "./element/step";
import {
    docEN
} from "./element/step";
import {
    formHeaderEN
} from "./element/otherComponent";
import {
    commonEN
} from "./common";
import {
    registrationFormEN
} from "./registerForm";
import {
    adminEN
} from "./element/admin";

import { applicationIDcardEN } from "./element/applicationIDcard";
import { qualifiedApplicantsEN } from "./element/qualifiedApplicants";
import { conditionEN } from "./element/conditionTermPage";
import { policyEN } from "./element/policyPage";

export const en = {
    message: {
        adminPage: adminEN,
        loginPage: loginEN,
        notFoundPage: notfoundEN,
        footer: footerEN,
        form: formEN,
        step2: step2EN,
        step3: step3EN,
        step4: step4EN,
        step5: step5EN,
        formSummit: formSummitEN,
        doc: docEN,
        formHeader: formHeaderEN,
        stepperBar: stepperBarEN,
        common: commonEN,
        registration_form: registrationFormEN,
        applicationIDcard:applicationIDcardEN,
        qualifiedApplicants:qualifiedApplicantsEN,

        conditionTermPage: conditionEN,
        policyPage: policyEN
    }
}
